import React from 'react';
import Box from "@material-ui/core/Box";
import { useTheme } from '@material-ui/core/styles';

export const Spacer = ({ style, size }) => {
    const theme = useTheme();
    return (
        <Box style={{padding: size*theme.spacing(), ...style}} ></Box>
    );
}

Spacer.NAME = "Spacer";

export default Spacer;